<div>
    <app-error-text message="Chargement des éléments impossible" *ngIf="loadingError"></app-error-text>
    <app-loading [showText]="false" *ngIf="loading"></app-loading>
    <mat-form-field style="width: 100%" appearance="outline" [style.display]="loading === false && !loadingError ? '' : 'none'">
        <mat-chip-list #chipList>
            <mat-chip
                    *ngFor="let value of selectedValues"
                    (removed)="remove(value)">
                {{resolveReadableValue(value)}}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
            <input [disabled]="maxValues > 0 && maxValues <= selectedValues.length"
                   [placeholder]="placeHolderLabel"
                   #input
                   (matChipInputTokenEnd)="add($event.value)"
                   (blur)=addOnBlur($event)
                   [formControl]="internalControl"
                   [matAutocomplete]="auto"
                   [matChipInputFor]="chipList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let element of filteredElements | async" [value]="element.value">
                <div [innerHTML]="element.label | keepHtml"></div>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</div>
